module.exports = __webpack_public_path__ + "img/shoper.98679c60.png";